// extracted by mini-css-extract-plugin
export default {"composer":"composer__Hnt+d","composer__input":"composer__input__d6OQi","composer--connecting":"composer--connecting__Z-5vJ"};